/**
 * Concrete {@link SwRegister} over `vite-plugin-pwa`'s `virtual:pwa-register`
 * module. This is the ONLY file that touches the virtual module, so everything
 * else (the pure `update-controller.ts`) stays testable outside Vite.
 *
 * `registerType: 'prompt'` (see `vite.config.ts`) means `registerSW` does NOT
 * auto-reload: it invokes `onNeedRefresh` when a new build's SW is waiting, and
 * the returned updater — called with `true` — messages that worker to
 * `skipWaiting()` and reloads the page onto the fresh assets.
 */
import { registerSW } from 'virtual:pwa-register';
import type { SwRegister } from './update-controller.ts';

/** Production registrar: bridges the injected handlers to the Workbox virtual module. */
export const registerServiceWorkerUpdates: SwRegister = (handlers) => {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh: handlers.onNeedRefresh,
    onOfflineReady: handlers.onOfflineReady,
  });
  return (reload) => updateSW(reload);
};
